
import { TOURIST_LOGIN, USER_INFO } from "../apis/user"

export default {
  data() {
    return {
    }
  },
  methods: {
    loginTourist(code, callback) {
      if (this.browser === "wechat") return;
      this.$post(
        `${TOURIST_LOGIN}?code=${code}`,
        {},
        (resp) => {
          if (resp.token) {
            this.$store.commit("token", resp.token)
            this.$store.commit("userType", "tourist_login")
            this.loadUser(callback)
          } else {
            // this.$router.push("/selectPakage?cabinetshow=true")
            this.allowedMaps = true
            this.$router.push("/home?cabinetshow=true")
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    loadUser(callback) {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            // this.$toast(this.i18n.msg_success_login)
            callback && callback(res)
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    },
    loginMpByCode(code) {
      this.$loading(true)
      this.$post(
        "loginByCode",
        { code },
        (resp) => {
          this.$loading(false)
          if (resp.token) {
            this.$store.commit("token", resp.token)
            this.loadUser(() => {
              this.$toast(this.i18n.msg_success_login)
            })
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    }
  }
}
